<template>
    <div>
        <div class="modal-header">
            <div class="modal-title">
                <a-icon type="medicine-box" style="margin-right:10px" />
                <span>{{l('Edit')}}</span>
            </div>
        </div>
        <div>
            <a-config-provider :locale="antdLocale">

                <a-row>
                    <a-col :span="11">
                        <a-row>
                            <a-col :span="24">
                                <a-form-item  :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"  :label="l('audit.inspectorname')">
										<a-input v-model="inspectorName"
										         :placeholder="l('Please_select_the_person_responsible')" allow-clear
										         style="width: 100%;" @click="respNameSelect"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item required :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" :label="l('audit.plandate')">
                                    <a-range-picker @change="timeChange" :default-value="[moment(planStart.format('YYYY-MM-DD'),'YYYY/MM/DD'), moment(planEnd.format('YYYY-MM-DD'),'YYYY/MM/DD')]" :placeholder="[l('audit.planstart'), l('audit.planend')]" style=" width: 100%;text-align: left;"/>
                                </a-form-item>
                            </a-col>
							<a-col :span="24">
								<a-form-item :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
								             :label="l('audit.name')">
								    <a-input v-model="taskName" :placeholder="l('please_enter_Title')" style="width: 100%;"></a-input>
								</a-form-item>
							</a-col>
							<a-col :span="24">
								<a-form-item :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
								             :label="l('Label')">
								    <a-select showSearch :filterOption="filterOption"
								              style="width: 100%;text-align: left;"
								              dropdownClassName="drop-down-Style" :dropdownMatchSelectWidth="false"
								              :placeholder="l('Please_select_a_label')"
								              allow-clear
								              mode="multiple"
								              @change="AuditTaskLabelChange"
											  v-model="AuditTaskLabel"
								    >
								        <a-select-option v-for="item in AuditTaskLabelList" :key="item.itemDetailCode"
								                         :title="item.itemDetailName">
								            {{ item.itemDetailName }}
								        </a-select-option>
								    </a-select>
								</a-form-item>
							</a-col>

                            <a-col :span="12">
                                <a-form-item :label-col="{ span: 10 }" :wrapper-col="{ span: 10 }"
                                             :label="l('Start_Early')">
                                    <a-input-number v-model="EarlyStart" :formatter="value => `${value}` + l('day')" :parser="value => value.replace(l('day'), '')" :min="0"></a-input-number>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item :label-col="{ span: 10 }" :wrapper-col="{ span: 10 }"
                                             :label="l('Delayed_Completion')">
                                    <a-input-number v-model="DelayedFinish" :formatter="value => `${value}` + l('day')" :parser="value => value.replace(l('day'), '')" :min="0"></a-input-number>
                                </a-form-item>
                            </a-col>

							<a-col :span="24" v-if="IsEnabled.filedExt1">
							    <a-form-item :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
							                 :label="l('filedExt1')">
							        <a-input v-model="filedExt1"></a-input>
							    </a-form-item>
							</a-col>
							
							<a-col :span="24" v-if="IsEnabled.filedExt2">
							    <a-form-item :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
							                 :label="l('filedExt2')">
							        <a-input v-model="filedExt2"></a-input>
							    </a-form-item>
							</a-col>
							
							<a-col :span="24" v-if="IsEnabled.filedExt3">
							    <a-form-item :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
							                 :label="l('filedExt3')">
							        <a-input v-model="filedExt3"></a-input>
							    </a-form-item>
							</a-col>
	
                            <a-col :span="24" v-if="IsEnabled.templateBarCode">
                                <a-form-item :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
                                             :label="l('TemplateBarCode')">
                                    <a-input v-model="TemplateBarCode"></a-input>
                                </a-form-item>
                            </a-col>

                            <a-col :span="24" v-if="IsEnabled.assitField">
                                <a-form-item :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
                                             :label="l('AssitField')">
                                    <a-input v-model="AssitField"></a-input>
                                </a-form-item>
                            </a-col>

                        </a-row>
                    </a-col>
                    <a-col :span="13">
                        <a-row>
                            <!--模板类型(创建方式)：与创建任务页同款式；任务的模板类型固定，不可切换-->
                            <a-col :span="24">
                                <a-form-item required :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
                                             :label="l('CreateMode')">
                                    <a-radio-group :value="templateType" disabled
                                                   style="display: flex; align-items: center; height: 32px;">
                                        <a-radio :value="1">
                                            {{l('AuditPointTemplate')}}
                                        </a-radio>
                                        <a-radio :value="2">
                                            {{l('AuditItemTemplate')}}
                                        </a-radio>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item required :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
                                             :label="l('audit.audittemplatename')">
                                    <!--任务只挂一个模板：当前模板整体替换，不做列表-->
                                    <div style="display: flex; align-items: center; flex-wrap: wrap;">
                                        <a-tag v-if="tags.length > 0" style="font-size: 1.1em; margin-right: 0;">
                                            {{ tags[0] }}
                                        </a-tag>
                                        <a-button v-if="canChangeTemplate" @click="selectaudittemplate"
                                                  style="margin-left: 8px;">
                                            <a-icon type="swap"/>
                                            {{l('AuditTask_ChangeTemplate')}}
                                        </a-button>
                                    </div>
                                </a-form-item>
                            </a-col>
                            <!--审核项模板任务：审核点集可在编辑时重新勾选(与创建任务页同一棵树)-->
                            <a-col :span="24" v-if="templateType === 2">
                                <a-form-item required :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"
                                             :label="l('please_select_AuditPoint')">
                                    <div style="width: 400px;height: 290px;border: 1px solid lightgray;overflow: auto;">
                                        <a-tree checkable v-model="checkedKeys" :tree-data="pointTreeData"
                                                :disabled="!canChangeTemplate"
                                                @check="onPointCheck"
                                                v-if="!pointTreeLoading">
                                        </a-tree>
                                    </div>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" :label="l('audit.remark')">
                                    <a-textarea :placeholder="l('please_enter_remark')" v-model="Remark" :rows="4" style="width: 400px;" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-col>



                </a-row>
            </a-config-provider>
        </div>
        <div class="modal-footer" v-if="!isLook">
            <a-button @click="close">
                {{l('Cancel')}}
            </a-button>
            <a-button :type="'primary'" @click="save">
                {{l('Save')}}
            </a-button>
        </div>
    </div>
</template>

<script>

    import ModalComponentBase from '../../../../shared/component-base/modal-component-base';
    import zh_CN from 'ant-design-vue/lib/locale/zh_CN';
    import {
        AuditItemGroupServiceProxy,
        AuditPointServiceProxy,
        AuditTaskServiceProxy,
        CreateAuditTaskDto,
        AuditTaskEditDto,
		SystemConfigServiceProxy
    } from '../../../../shared/service-proxies';
    import CreatErrorCode from "../../audit-items/new-item/new-item";
    import selectmodel from "../audit-template-model/audit-template-model";
    import selectitemmodel from "../audit-item-template-model/audit-item-template-model";
    import { ModalHelper } from '@/shared/helpers';
    import moment from "moment";
	import {Dic} from "../../../../shared/utils";
	import PersonnelSelection from "../../Personnel-selection/Personnel-selection.vue";

    let _this;

    export default {
        name: "update-audit-task",
        mixins: [ModalComponentBase],
        components: {

        },
        created() {
            this.fullData(); // 模态框必须,填充数据到data字段
            this.AuditItemGroupServiceProxy = new AuditItemGroupServiceProxy(this.$apiUrl, this.$api);
            this.AuditTaskServiceProxy = new AuditTaskServiceProxy(this.$apiUrl, this.$api);
            this.AuditPointServiceProxy = new AuditPointServiceProxy(this.$apiUrl, this.$api);
			this.SystemConfigServiceProxy = new SystemConfigServiceProxy(this.$apiUrl, this.$api);
        },
        async mounted() {
            this.isLoading = true;
            this.AuditTaskServiceProxy.getForEdit(
                this.id
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.inspectorId = res.inspectorId;
				this.inspectorName = res.inspectorName;
                this.taskName = res.name;
                this.planStart = res.planStart;
                this.planEnd = res.planEnd.add(-1, 'days');
                this.EarlyStart = res.earlyStart;
                this.DelayedFinish = res.delayedFinish;
                this.TemplateBarCode = res.templateBarCode;
                this.AssitField = res.assitField;
				this.filedExt1 = res.filedExt1;
				this.filedExt2 = res.filedExt2;
				this.filedExt3 = res.filedExt3;
                
				if(res.auditTaskLabel===null) {
				}else {
					this.AuditTaskLabel = res.auditTaskLabel;
				}
				this.auditTaskState = res.auditTaskState;
				this.templateType = res.templateType;
				this.originalTemplateId = res.auditTemplateId;
                this.AuditTemplate.push(res.auditTemplateId)
                this.tags.push(res.auditTemplateName)
				if (res.templateType === 2) {
					this.loadPointTree();
				}
            })
			try {
			    this.loading = true;
				this.AuditTaskLabelList = await Dic.getInstance().getDicAsync('AuditTaskLabel');
			} catch (e) {
			    
			} finally {
			    this.loading = false;
			}
			this.getIsEnable();
        },
        data() {
            return {
                zh_CN,
                id:undefined,
                isEdit: false,//是否是编辑
                isLook: false,//是否是查看
                entity: [],
                pId: undefined,
                treeDataList: [],
                treeReplaceFields: {
                    title: 'name',
                    key: 'id',
                    value: 'id'
                },
                itemid: undefined,
                isLoading:false,
                AllLPAUser:[],

                tags: [],
                inputVisible: false,
                inputValue: '',

                UserIds:[],
                StartDateTime:[],
                EndDateTime:[],
                AuditTemplate:[],
                AuditItem:[],
                AuditPoint:[],
                Remark:"",

                newAuditTemplate:[],
                inspectorId:undefined,
				inspectorName:undefined,
                taskName:undefined,
                planStart:undefined,
                planEnd:undefined,
				isclick: true,
				AuditTaskLabel: [],
				AuditTaskLabelList: [],
				loading: false,
                EarlyStart:undefined,
                DelayedFinish:undefined,
				filedExt1: undefined,
				filedExt2: undefined,
				filedExt3: undefined,
				auditTaskState: undefined,
				templateType: undefined,
				originalTemplateId: undefined,
				pointTreeData: [],
				checkedKeys: [],
				pointTouched: false,
				pointTreeLoading: false,
				IsEnabled: {
					filedExt1: false,
					filedExt2: false,
					filedExt3: false,
					templateBarCode: false,
					assitField: false
				}
            }
        },
        computed: {
            //已完成(3)、延期完成(6)的任务不允许换模板
            canChangeTemplate() {
                return this.auditTaskState !== '3'
                    && this.auditTaskState !== '6';
            },
        },
        methods: {

            moment,

            //获取是否启用条码和辅助字段
            getIsEnable() {
            	this.isLoading = true;
            	this.SystemConfigServiceProxy.getFiledExtSettings(
            		
            	).finally(() => {
            	    this.isLoading = false;
            	}).then(res => {
            		this.IsEnabled = res;
            	})
            },

            handleClose(removedTag) {
                const tags = this.tags.filter(tag => tag !== removedTag);
                console.log(tags);
                this.tags = tags;
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(function() {
                    this.$refs.input.focus();
                });
            },

            handleInputChange(e) {
                this.inputValue = e.target.value;
            },

            handleInputConfirm() {
                const inputValue = this.inputValue;
                let tags = this.tags;
                if (inputValue && tags.indexOf(inputValue) === -1) {
                    tags = [...tags, inputValue];
                }
                console.log(tags);
                Object.assign(this, {
                    tags,
                    inputVisible: false,
                    inputValue: '',
                });
            },

			AuditTaskLabelChange(value) {
			    this.AuditTaskLabel = value;
			},

            xiuxi(){

                return;
                if(this.AuditTemplate.length <= 0){
                    this.AuditTemplate.push(0);
                    this.tags.push("空方案");
                }
                else{
                    if(Math.min(...this.AuditTemplate) <= 0){
                        let min = Math.min(...this.AuditTemplate) // 1
                        this.AuditTemplate.push(min-1);
                        this.tags.push("空方案" + Math.abs(min-1));
                    }
                    else{
                        this.AuditTemplate.push(0);
                        this.tags.push("空方案");
                    }
                }

            },


            selectaudittemplate(){
                //按任务模板类型选弹窗：2=审核项模板(返回数组取第一条)，其余=审核点模板
                if (this.templateType === 2) {
                    ModalHelper.create(selectitemmodel, {}, { width: 1000 }).subscribe((res) => {
                        if (res && res.length > 0) {
                            this.AuditTemplate = [res[0].id];
                            this.tags = [res[0].name];
                        }
                    });
                    return;
                }
                ModalHelper.create(selectmodel, {
                }).subscribe(res => {
                    console.log(res)
                    if(res){
                        //任务只挂一个模板，编辑时选择即整体替换
                        this.AuditTemplate = [res.id]
                        this.tags = [res.name];
                    }
                })
            },


            //审核项模板任务：加载审核点树并回显任务当前点集(树数据与创建任务页同源)
            loadPointTree() {
                this.pointTreeLoading = true;
                this.AuditPointServiceProxy.getAllData().finally(() => {
                    this.pointTreeLoading = false;
                }).then(res => {
                    this.pointTreeData = res;
                });
                //只取去重后的审核点Id集，避免拉取整个任务明细大结果集
                this.AuditTaskServiceProxy.getAuditTaskPointIds(
                    this.id
                ).then(res => {
                    this.checkedKeys = res || [];
                });
            },

            onPointCheck() {
                this.pointTouched = true;
            },

            unique (arr) {
                return Array.from(new Set(arr))
            },


            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },

            timeChange(date, dateString) {
                console.log(date, dateString);
                this.StartDateTime = [];
                this.EndDateTime = [];
                this.StartDateTime.push(date[0]);
                this.EndDateTime.push(date[1])

                this.planStart = date[0];
                this.planEnd = date[1];

                console.log(this.StartDateTime)
                console.log(this.EndDateTime)
            },

            getAllLPAUser(){
                this.isLoading = true;
                this.AuditTaskServiceProxy.getAllLPAUsers(
                )
                    .finally(() => {
                        this.isLoading = false;
                    })
                    .then((res) => {
                        console.log(res);
                        this.AllLPAUser = res;
                    })
            },

            LPAUserChange(value){
                console.log(value);
                this.UserIds = value;
                console.log(this.UserIds)
            },

            getTreeData() {
                this.isLoading = true;
                this.AuditItemGroupServiceProxy.getPaged(
                    undefined,
                )
                    .finally(() => {
                        this.isLoading = false;
                    })
                    .then((res) => {
                        console.log(res);
                        this.treeDataList = JSON.parse(JSON.stringify(res));
                    })
            },
            save() {
                if (!this.planStart) {
                    abp.message.info(this.l('AuditTask_SelectTime'));
                    return;
                }

                //更换模板/调整审核点都会重建任务明细、清空已填写的审核结果，需二次确认
                const newTemplateId = this.AuditTemplate.length > 0 ? this.AuditTemplate[0] : undefined;
                const templateChanged = !!newTemplateId && !!this.originalTemplateId && newTemplateId !== this.originalTemplateId;
                const pointChanged = this.templateType === 2 && this.pointTouched;
                if (pointChanged && this.checkedKeys.length <= 0) {
                    abp.message.info(this.l('AuditTask_SelectAtLeastOnePoint'));
                    return;
                }
                if (templateChanged || pointChanged) {
                    const actions = [];
                    if (templateChanged) {
                        actions.push(this.l('AuditTask_ChangeTemplate') + this.l(this.templateType === 2 ? 'AuditTask_ItemTemplateWord' : 'AuditTask_PointTemplateWord'));
                    }
                    if (pointChanged) {
                        actions.push(this.l('AuditTask_AdjustPoints'));
                    }
                    abp.message.confirm(
                        this.l('AuditTask_ResetConfirm', actions.join(this.l('AuditTask_AndWord'))),
                        isConfirmed => {
                            if (isConfirmed) {
                                this.doSave();
                            }
                        }
                    );
                    return;
                }
                this.doSave();
            },

            doSave() {
                let entity = new AuditTaskEditDto();
                entity.id = this.id;
                entity.name = this.taskName;
                entity.inspectorId = this.inspectorId;
                entity.planStart = this.planStart;
                entity.planEnd = this.planEnd.add(1, 'days');
                entity.remark = this.Remark;
				entity.auditTaskLabel = this.AuditTaskLabel.toString();
                entity.earlyStart = this.EarlyStart;
                entity.delayedFinish = this.DelayedFinish;
                entity.templateBarCode = this.TemplateBarCode;
                entity.assitField = this.AssitField;
				entity.filedExt1 = this.filedExt1;
				entity.filedExt2 = this.filedExt2;
				entity.filedExt3 = this.filedExt3;
				entity.auditTemplateId = this.AuditTemplate.length > 0 ? this.AuditTemplate[0] : undefined;
				//先序列化代理 DTO，再补充代理尚未声明的审核点集，避免 toJSON 丢弃该字段
				const request = entity.toJSON();
				if (this.templateType === 2 && this.pointTouched) {
					request.auditPointIdList = this.checkedKeys;
				}
				if(this.isclick) {
					this.isclick = false;
					this.AuditTaskServiceProxy.update(
						request
					).finally(() => {

					}).then(res => {
						this.isclick = true;
					    this.success(true);
					})
				}

            },
			
			respNameSelect() {
				ModalHelper.create(PersonnelSelection, {
					respId: this.inspectorId,
					isSelect: true,
					userType: 2
				}, {
					width: 800
				}).subscribe(res => {
					if (res) {
						this.inspectorName = res[0].realName;
						this.inspectorId = res[0].userId;
					}
				})
			},

        }
    }
</script>

<style>
    .ant-form-item{
        margin-bottom: 5px;
        display: flex;
        align-items: center;  /* 标签与输入框垂直居中 */
    }
</style>
